import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { Template as ContentHeaderTemplate } from "../../partial-templates/nimbus/content-header/content-header.templates";
import {
    Template as TeaserContactTemplate,
    templateArgs as teaserContactArgs,
} from "../../partial-templates/nimbus/teaser-contact/teaser-contact.templates";
import {
    Template as TeaserProductTemplate,
    templateArgs as teaserProductArgs,
} from "../../partial-templates/nimbus/teaser-product/teaser-product.templates";
import { FilterTemplate } from "./product-overview-filter.templates";

const Template = () => html`
    <div>
        <div class="ux-t-container-full ux-theme-nimbus">${ContentHeaderTemplate()}
            ${FilterTemplate()}
            <ux-iws-data-controller-product-overview
                filter-selector="#product-overview-filter"
                counter-selector=".product-overview-counter"
            >
                <script type="text/template" slot="contact-template">
                    ${TeaserContactTemplate({
                        ...teaserContactArgs,
                        className: "ux-u-mb-fluid-m",
                    })}
                </script>
                <div slot="counter">
                    <div class="ux-row">
                        <div class="ux-col-12">
                            <div class="ux-u-margin-bottom-15 ux-text-normal">
                                <span class="product-overview-counter">
                                    0
                                </span>
                                <span> Products</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="results-container">
                    ${TeaserProductTemplate({
                        ...teaserProductArgs,
                        className: "ux-u-mb-fluid-m",
                        filterAttribute: "Schweissen,15,16",
                        tags: "Schweissen",
                        highlightedTags: "",
                    })}
                    ${TeaserProductTemplate({
                        ...teaserProductArgs,
                        className: "ux-u-mb-fluid-m",
                        filterAttribute: "Schweissen,15",
                        tags: "Schweissen",
                        highlightedTags: "",
                    })}
                    ${TeaserProductTemplate({
                        ...teaserProductArgs,
                        className: "ux-u-mb-fluid-m",
                        filterAttribute: "Schweissen,Markieren,14",
                        tags: "Schweissen,Markieren",
                        highlightedTags: "",
                    })}
                    ${TeaserProductTemplate({
                        ...teaserProductArgs,
                        className: "ux-u-mb-fluid-m",
                        filterAttribute: "Schneiden,19",
                        tags: "Schneiden",
                        highlightedTags: "",
                    })}
                    ${TeaserProductTemplate({
                        ...teaserProductArgs,
                        className: "ux-u-mb-fluid-m",
                        filterAttribute: "Schneiden,14",
                        tags: "Schneiden",
                        highlightedTags: "",
                    })}
                    ${TeaserProductTemplate({
                        ...teaserProductArgs,
                        className: "ux-u-mb-fluid-m",
                        filterAttribute: "Schneiden,17",
                        tags: "Schneiden",
                        highlightedTags: "",
                    })}
                    ${TeaserProductTemplate({
                        ...teaserProductArgs,
                        className: "ux-u-mb-fluid-m",
                        filterAttribute: "Schneiden,18",
                        tags: "Schneiden",
                        highlightedTags: "",
                    })}
                </div>
            </ux-iws-data-controller-product-overview>
        </div>
    </div>
    </div>
`;

export default {
    title: "Website/Page Templates/Nimbus/Product Overview Page",
    render: Template.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        layout: "fullscreen",
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
